(() => {
  'use strict';

  function maisonUpdateHeaderHeight() {
    const maisonHeader = document.querySelector('.maison-header-group');
    if (maisonHeader) document.documentElement.style.setProperty('--maison-header-height', `${maisonHeader.getBoundingClientRect().height}px`);
  }

  function maisonWithin(maisonScope, maisonSelector) {
    return [...(maisonScope.matches?.(maisonSelector) ? [maisonScope] : []), ...(maisonScope.querySelectorAll?.(maisonSelector) || [])];
  }

  function maisonInitStickyPurchase(maisonScope = document) {
    maisonWithin(maisonScope, '[data-maison-sticky-purchase]:not([data-maison-ready])').forEach((maisonBar) => {
      const maisonRoot = maisonBar.closest('[data-maison-product-root]');
      const maisonNativeButton = maisonRoot?.querySelector('[data-add-to-cart]');
      const maisonButton = maisonBar.querySelector('button');
      const maisonPrice = maisonRoot?.querySelector('[data-maison-price]');
      if (!maisonNativeButton || !maisonButton) return;
      maisonBar.dataset.maisonReady = 'true';
      const maisonController = new AbortController();
      const maisonSync = () => {
        maisonButton.disabled = maisonNativeButton.disabled;
        // Alleen de leesbare tekst, nooit de letters van de hover-animatie. Stoq
        // (pre-order) vervangt de knopinhoud door kale tekst en daarna bouwt de
        // runtime de animatie opnieuw; textContent van de hele knop gaf dan
        // "...winkelwagenVVooeegg PPrree..." in de balk (gezien 4-11-2026).
        const maisonLabelVan = (maisonEl) => {
          const maisonAcc = maisonEl.querySelector('.maison-button-label__accessible');
          if (maisonAcc?.textContent.trim()) return maisonAcc.textContent.trim();
          const maisonKloon = maisonEl.cloneNode(true);
          maisonKloon.querySelectorAll('.maison-button-label, [aria-hidden="true"], svg').forEach((maisonN) => maisonN.remove());
          return maisonKloon.textContent.trim() || maisonEl.textContent.trim();
        };
        maisonButton.textContent = maisonLabelVan(maisonNativeButton.querySelector('[data-add-to-cart-text]') || maisonNativeButton);
        maisonButton.setAttribute('aria-busy', maisonNativeButton.getAttribute('aria-busy') || 'false');
        const maisonBarPrice = maisonBar.querySelector('[data-maison-sticky-price]');
        if (maisonPrice && maisonBarPrice.textContent !== maisonPrice.textContent) maisonBarPrice.textContent = maisonPrice.textContent;
      };
      // Delegate to the original button, preserving Broadcast, Kaching properties and app interception.
      maisonButton.addEventListener('click', () => { if (!maisonNativeButton.disabled && !maisonRoot.inert) maisonNativeButton.click(); }, { signal: maisonController.signal });
      const maisonStateObserver = new MutationObserver(maisonSync);
      maisonStateObserver.observe(maisonNativeButton, { attributes: true, childList: true, subtree: true, characterData: true });
      if (maisonPrice) maisonStateObserver.observe(maisonPrice, { childList: true, subtree: true, characterData: true });
      const maisonUpdateVisibility = () => {
        const maisonRect = maisonNativeButton.getBoundingClientRect();
        // Een stuk van de knop in beeld betekent: geen balk nodig.
        const maisonZichtbaar = maisonRect.bottom >= 0 && maisonRect.top <= window.innerHeight;
        // Helemaal bovenaan laten we het eerste beeld met rust, ook als de knop
        // daar nog onder staat. Zodra er gescrold wordt verschijnt de balk.
        const maisonEersteBeeld = window.scrollY < 40 && maisonRect.top > window.innerHeight;
        maisonBar.hidden = maisonRect.height === 0 || maisonZichtbaar || maisonEersteBeeld;
      };
      const maisonSizeObserver = new ResizeObserver(() => {
        const maisonHeight = maisonBar.getBoundingClientRect().height;
        if (maisonHeight) document.documentElement.style.setProperty('--maison-sticky-purchase-height', `${maisonHeight}px`);
      });
      maisonSizeObserver.observe(maisonBar);
      const maisonVisibilityObserver = new IntersectionObserver(maisonUpdateVisibility);
      maisonVisibilityObserver.observe(maisonNativeButton);
      // Anchor jumps can skip the observer's intersection boundary in a single frame.
      let maisonScrollFrame = 0;
      const maisonOnScroll = () => {
        if (maisonScrollFrame) return;
        maisonScrollFrame = requestAnimationFrame(() => { maisonScrollFrame = 0; maisonUpdateVisibility(); });
      };
      window.addEventListener('scroll', maisonOnScroll, { passive: true });
      maisonBar.maisonCleanup = () => {
        maisonController.abort();
        delete maisonBar.dataset.maisonReady;
        maisonStateObserver.disconnect();
        maisonVisibilityObserver.disconnect();
        maisonSizeObserver.disconnect();
        window.removeEventListener('scroll', maisonOnScroll);
        cancelAnimationFrame(maisonScrollFrame);
        document.documentElement.style.removeProperty('--maison-sticky-purchase-height');
        delete maisonBar.maisonCleanup;
      };
      maisonUpdateVisibility();
      maisonSync();
    });
  }

  function maisonInitCatalogSwatches(maisonScope = document) {
    const maisonData = window.starapps_data;
    if (!maisonData?.product_groups || !maisonData.product_groups_chart) return;
    maisonWithin(maisonScope, '[data-maison-product-handle] [data-maison-card-swatches]:not([data-maison-catalog-ready])').forEach((maisonSlot) => {
      if (maisonSlot.querySelector('a')) { maisonSlot.dataset.maisonCatalogReady = 'true'; return; }
      const maisonHandle = maisonSlot.closest('[data-maison-product-handle]').dataset.maisonProductHandle;
      const maisonGroup = (maisonData.product_groups_chart[maisonHandle] || [])
        .map((maisonIndex) => maisonData.product_groups[maisonIndex])
        .find((maisonGroup) => /color|colour|finish|material/i.test(maisonGroup?.option_name || ''));
      if (!maisonGroup) return;
      const maisonOptions = maisonGroup.option_values.filter((maisonOption) => maisonOption.published && maisonOption.handle && maisonOption.option_value);
      if (maisonOptions.length < 2) return;
      maisonSlot.dataset.maisonCatalogReady = 'true';
      const maisonList = document.createElement('div');
      maisonList.className = 'maison-catalog-swatches';
      maisonList.setAttribute('aria-label', maisonGroup.option_name);
      maisonOptions.forEach((maisonOption, maisonIndex) => {
        const maisonName = maisonOption.option_value.trim();
        const maisonLink = document.createElement('a');
        const maisonUrl = new URL(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(maisonOption.handle)}`, location.origin);
        maisonUrl.searchParams.set('view', 'maison');
        const maisonPreview = new URL(location.href).searchParams.get('preview_theme_id');
        if (maisonPreview) maisonUrl.searchParams.set('preview_theme_id', maisonPreview);
        maisonLink.href = maisonUrl.pathname + maisonUrl.search;
        maisonLink.className = 'maison-catalog-swatches__item' + (maisonIndex >= 5 ? ' maison-catalog-swatches__item--verborgen' : '');
        maisonLink.dataset.maisonSwatchHandle = maisonOption.handle;
        maisonLink.title = maisonName;
        maisonLink.setAttribute('aria-label', maisonName);
        if (maisonOption.handle === maisonHandle) maisonLink.setAttribute('aria-current', 'true');
        const maisonMaterial = window.MaisonMaterialSwatch?.(maisonName);
        if (maisonMaterial?.background) maisonLink.style.backgroundImage = maisonMaterial.background;
        else if (maisonMaterial?.image) maisonLink.style.backgroundImage = `url("${maisonMaterial.image}")`;
        else if (maisonMaterial?.color) maisonLink.style.backgroundColor = maisonMaterial.color;
        else { maisonLink.classList.add('maison-catalog-swatches__item--label'); maisonLink.textContent = maisonName; }
        maisonList.append(maisonLink);
      });
      if (maisonOptions.length > 5) {
        // Een knop, geen link: hij laat de overige kleuren zien in plaats van
        // naar het product te springen.
        const maisonMore = document.createElement('button');
        maisonMore.type = 'button';
        maisonMore.className = 'maison-catalog-swatches__more';
        maisonMore.dataset.maisonSwatchMeer = 'true';
        maisonMore.textContent = `+${maisonOptions.length - 5}`;
        maisonMore.setAttribute('aria-label', document.documentElement.dataset.maisonSwatchLabel || `Show all ${maisonOptions.length} finishes`);
        maisonList.append(maisonMore);
      }
      maisonSlot.replaceChildren(maisonList);
    });
  }

  function maisonInit(maisonScope = document) {
    maisonUpdateHeaderHeight();
    maisonInitStickyPurchase(maisonScope);
    maisonInitCatalogSwatches(maisonScope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => maisonInit(), { once: true });
  else maisonInit();
  document.addEventListener('maison:content-loaded', (maisonEvent) => maisonInit(maisonEvent.detail?.scope || document));
  document.addEventListener('shopify:section:load', (maisonEvent) => maisonInit(maisonEvent.target));
  const maisonUnload = (maisonScope) => {
    maisonWithin(maisonScope, '[data-maison-sticky-purchase]').forEach((maisonBar) => maisonBar.maisonCleanup?.());
    if (maisonActieveDot && (maisonScope === maisonActieveDot || maisonScope.contains?.(maisonActieveDot))) maisonActieveDot = null;
  };
  document.addEventListener('shopify:section:unload', (maisonEvent) => maisonUnload(maisonEvent.target));
  document.addEventListener('maison:content-unloading', (maisonEvent) => maisonUnload(maisonEvent.detail?.scope || maisonEvent.target));
  window.addEventListener('resize', maisonUpdateHeaderHeight, { passive: true });
  let maisonAttempts = 0;
  const maisonAppTimer = setInterval(() => {
    maisonInitCatalogSwatches();
    if (window.starapps_data?.product_groups || ++maisonAttempts >= 30) clearInterval(maisonAppTimer);
  }, 500);

  /* Kleurrondjes op de productkaarten.
     Zweven over een rondje laat de foto van die kleur zien, het plusje klapt
     de overige kleuren uit. Dit loopt via document, zodat ook kaarten die de
     slider later bijmaakt meteen werken. */
  function maisonKaartFoto(maisonDot) {
    const maisonKaart = maisonDot.closest('[data-maison-product-card], .maison-collection-products__card, article, li');
    if (!maisonKaart) return null;
    return maisonKaart.querySelector('[class*="__media"] img') || maisonKaart.querySelector('picture img') || maisonKaart.querySelector('img');
  }

  const maisonFotoCache = new Map();
  let maisonActieveDot = null;

  async function maisonZoekFoto(maisonDot) {
    if (maisonDot.dataset.maisonSwatchFoto) return maisonDot.dataset.maisonSwatchFoto;
    const maisonHandle = maisonDot.dataset.maisonSwatchHandle;
    if (!maisonHandle) return null;
    if (maisonFotoCache.has(maisonHandle)) return maisonFotoCache.get(maisonHandle);
    try {
      const maisonRoot = window.Shopify?.routes?.root || '/';
      const maisonAntwoord = await fetch(`${maisonRoot}products/${maisonHandle}.js`);
      const maisonJson = await maisonAntwoord.json();
      const maisonUrl = maisonJson.featured_image || (maisonJson.images && maisonJson.images[0]) || null;
      maisonFotoCache.set(maisonHandle, maisonUrl);
      return maisonUrl;
    } catch (maisonFout) {
      maisonFotoCache.set(maisonHandle, null);
      return null;
    }
  }

  async function maisonSwatchToon(maisonEvent) {
    const maisonDot = maisonEvent.target.closest('[data-maison-swatch-foto], [data-maison-swatch-handle]');
    if (!maisonDot) return;
    const maisonFoto = maisonKaartFoto(maisonDot);
    if (!maisonFoto) return;
    maisonActieveDot = maisonDot;
    if (!maisonFoto.dataset.maisonFotoOrigineel) {
      maisonFoto.dataset.maisonFotoOrigineel = maisonFoto.currentSrc || maisonFoto.src || '';
      maisonFoto.dataset.maisonSetOrigineel = maisonFoto.getAttribute('srcset') || '';
    }
    const maisonUrl = await maisonZoekFoto(maisonDot);
    if (!maisonUrl || maisonActieveDot !== maisonDot || !maisonDot.isConnected || !maisonFoto.isConnected) return;
    maisonFoto.removeAttribute('srcset');
    maisonFoto.removeAttribute('sizes');
    maisonFoto.src = maisonUrl;
  }

  function maisonSwatchHerstel(maisonEvent) {
    const maisonDot = maisonEvent.target.closest('[data-maison-swatch-foto], [data-maison-swatch-handle]');
    if (!maisonDot) return;
    if (maisonActieveDot === maisonDot) maisonActieveDot = null;
    const maisonFoto = maisonKaartFoto(maisonDot);
    if (!maisonFoto || !maisonFoto.dataset.maisonFotoOrigineel) return;
    if (maisonFoto.dataset.maisonSetOrigineel) maisonFoto.setAttribute('srcset', maisonFoto.dataset.maisonSetOrigineel);
    maisonFoto.src = maisonFoto.dataset.maisonFotoOrigineel;
  }

  document.addEventListener('mouseover', maisonSwatchToon);
  document.addEventListener('focusin', maisonSwatchToon);
  document.addEventListener('mouseout', maisonSwatchHerstel);
  document.addEventListener('focusout', maisonSwatchHerstel);
  document.addEventListener('click', (maisonEvent) => {
    const maisonMeer = maisonEvent.target.closest('[data-maison-swatch-meer]');
    if (!maisonMeer) return;
    maisonEvent.preventDefault();
    const maisonGroep = maisonMeer.closest('.maison-collection-products__swatches, .maison-catalog-swatches');
    if (maisonGroep) maisonGroep.classList.add('maison-collection-products__swatches--open', 'maison-catalog-swatches--open');
    maisonMeer.remove();
  });

})();
